import React from "react";
import { useSelector } from "react-redux";

import styled from "styled-components";
import { selectUser } from "../../Redux/user/user";
import HeaderMenu from "./HeaderMenu";

const Header = ({ theme, toggleTheme }) => {

  const user = useSelector(selectUser);


  return (
    <Container>
      <HeaderMenuWrapper >
        <HeaderMenu theme={theme} toggleTheme={toggleTheme} />
      </HeaderMenuWrapper>

    </Container>
  );
};

export default Header;
const Container = styled.div`
  top: 0;
  display: flex;
  justify-content: space-between;
  background: var(--darkBlue);
  align-items: center;
  min-height:45px;
  width: 100%;
  padding: 0 20px;

`;
const HeaderMenuWrapper = styled.div`
display:flex;
margin-left:auto;
`


